import { Paragraph, TextRun, BorderStyle, TableCell, TableRow, AlignmentType, WidthType, VerticalAlign, Table, ShadingType } from "docx";

export const determination = new Paragraph({
    spacing: { before: 250, after: 350 },
    children: [
        new TextRun({
            text: "Severity Determination",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const determination1 = new Paragraph({
    spacing: { line: 276 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: `This section provides the indication of the severity of vulnerabilities identified, and the priority with which the same needs to be addressed by business units. The vulnerabilities are categorized as per industry framework "Common Vulnerability Scoring System v3.1" i.e. CVSS3.1 scoring. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments.`,
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const determination2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 350, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Note:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: true
        }),
        new TextRun({
            text: " Business units should supplement the base CVSS score with the contextual analysis of the environment, and with attributes that may change over time by leveraging CVSS Temporal and Environmental Metrics. More appropriately, a comprehensive risk assessment system should be employed that considers more factors than simply the CVSS Base Score and represent actual risk.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})

export const cvssMapping = new Paragraph({
    spacing: { before: 500, after: 350 },
    children: [
        new TextRun({
            text: "CVSS 3.1 MAPPING",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const cvssMappingTable = new Table({
    width: { size: 45, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity Category",
                                    font: "Arial",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "002060" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CVSS Score Range",
                                    font: "Arial",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "002060" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Critical",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "9.0 - 10",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "High",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "7.0 - 8.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Medium",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "4.0 -6.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Low",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.1 - 3.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Informational",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.0",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
    ]
})